import { DisponibilityChoice, DogAffinityChoice } from '@/data'
import { StoreActionMap } from '@/store/types'
import { DogBreed } from '@/dataV3/Animal/DogBreed'
import { DogSize } from '@/dataV3/Animal/DogSize'

export interface ConfigurationReducer {
  disponibilityChoices: DisponibilityChoice[]
  dogAffinityChoices: DogAffinityChoice[]
  dogBreeds: DogBreed[]
  catBreeds: DogBreed[]
  nacBreeds: DogBreed[]
  dogSizes: DogSize[]
}

export const initialConfigurationReducerState: ConfigurationReducer = {
  disponibilityChoices: [],
  dogAffinityChoices: [],
  dogBreeds: [],
  catBreeds: [],
  nacBreeds: [],
  dogSizes: [],
}

export enum ConfigurationTypes {
  Restore = 'Configuration/RESTORE',
  UpdateDisponibilityChoices = 'Configuration/UPDATE_DISPONIBILITY_CHOICES',
  UpdateDogAffinityChoices = 'Configuration/UPDATE_DOG_AFFINITY_CHOICES',
  UpdateDogBreeds = 'Configuration/UPDATE_DOG_BREEDS',
  UpdateCatBreeds = 'Configuration/UPDATE_CAT_BREEDS',
  UpdateNacBreeds = 'Configuration/UPDATE_NAC_BREEDS',
  UpdateDogSizes = 'Configuration/UPDATE_DOG_SIZES',
}

type ConfigurationPayload = {
  [ConfigurationTypes.Restore]: ConfigurationReducer
  [ConfigurationTypes.UpdateDisponibilityChoices]: DisponibilityChoice[]
  [ConfigurationTypes.UpdateDogAffinityChoices]: DogAffinityChoice[]
  [ConfigurationTypes.UpdateDogBreeds]: DogBreed[]
  [ConfigurationTypes.UpdateCatBreeds]: DogBreed[]
  [ConfigurationTypes.UpdateNacBreeds]: DogBreed[]
  [ConfigurationTypes.UpdateDogSizes]: DogSize[]
}

export type ConfigurationActions = StoreActionMap<ConfigurationPayload>[keyof StoreActionMap<ConfigurationPayload>]

const configurationReducer = (curState: ConfigurationReducer, action: ConfigurationActions): ConfigurationReducer => {
  switch (action.type) {
    case ConfigurationTypes.Restore:
      return {
        ...action.payload,
      }
    case ConfigurationTypes.UpdateDisponibilityChoices:
      return {
        ...curState,
        disponibilityChoices: action.payload,
      }
    case ConfigurationTypes.UpdateDogAffinityChoices:
      return {
        ...curState,
        dogAffinityChoices: action.payload,
      }
    case ConfigurationTypes.UpdateDogBreeds:
      return {
        ...curState,
        dogBreeds: action.payload,
      }
    case ConfigurationTypes.UpdateCatBreeds:
      return {
        ...curState,
        catBreeds: action.payload,
      }
    case ConfigurationTypes.UpdateNacBreeds:
      return {
        ...curState,
        nacBreeds: action.payload,
      }
    case ConfigurationTypes.UpdateDogSizes:
      return {
        ...curState,
        dogSizes: action.payload,
      }
    default:
      return curState
  }
}

export default configurationReducer
